import React, { Fragment } from "react";
import ReactDOM from "react-dom";
import { connect } from "react-redux";
import { Link } from "react-router-dom";

import Loader from "../Loader/Loader.js";
import { ComponentWithUrl } from "./../Utils/Utils.js";
import InsightLatest from "../InsightsLatest/InsightLatest.js";
import Heading from "../Elements/Heading.js";
import CloseIcon from "./../../i/icons/close.svg";

const insightsRoot = document.getElementById("insights-root");

class InsightsLatestList extends ComponentWithUrl {
  renderSections = (data) =>
    data.map((insights, index) => (
      <article className="mb-2" key={index}>
        {this.renderInsights(insights.data)}
      </article>
    ));

  renderInsights = (data) =>
    data.map((insight, index) => {
      return (
        <Fragment key={index}>
          <InsightLatest {...insight} key={index} />
          <hr className="insight__hr" />
        </Fragment>
      );
    });

  render() {
    const { loading, data, property } = this.props;

    if (loading) {
      return <Loader minHeight={200} col={"col-12"} />;
    }

    return ReactDOM.createPortal(
      <div className="insights-recent-container">
        <main className="insights">
          <header className="todays-insight__header row mb-4">
            <div className="col">
              <Heading size={4}>Today's Insights</Heading>
            </div>
            <div className="col text-right">
              <button
                onClick={() => this.props.closeInsightsPortal()}
                className="todays-insight__close"
              >
                <img src={CloseIcon} alt="Close Insights" />
              </button>
            </div>
          </header>

          {this.renderSections(data.data)}

          <div className="text-center mt-4">
            <Link
              to={`/${property}/insights`}
              className="todays-insight__more"
              onClick={() => this.props.closeInsightsPortal()}
            >
              <Heading size={6} key={"heading"}>
                View More
              </Heading>
            </Link>
          </div>
        </main>
      </div>,
      insightsRoot
    );
  }
}

const mapStateToProps = (state, props) => {
  const myState = state.data[props.url];
  return {
    data: myState ? myState.data : null,
    loading: myState ? myState.loading : true,
  };
};

export default connect(mapStateToProps)(InsightsLatestList);
